"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { FormProvider } from "@/integrations/forms/FormProvider";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_1.png-wvc-sizes",
  alt: "Lavender field photography session 1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_2.png-wvc-sizes",
  alt: "Lavender field photography session 2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_3.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_3.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_3.webp-wvc-sizes",
  alt: "Lavender field photography session 3"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_4.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_4.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_4.webp-wvc-sizes",
  alt: "Lavender field photography session 4"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_5.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_5.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_5.png-wvc-sizes",
  alt: "Lavender field photography session 5"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_6.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_6.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_session_6.png-wvc-sizes",
  alt: "Lavender field photography session 6"
}];
export default function Details() {
  return <section id="details-section" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          
          {}
          <div className="flex flex-col">
            <h2 className="font-default text-3xl md:text-4xl text-foreground mb-4">
              Photography Sessions Available
            </h2>
            <Separator className="w-12 h-1 bg-foreground mb-8" />
            
            <div className="space-y-6 text-muted-foreground leading-relaxed">
              <p>
                If you are a photographer – professional or hobbyist – we have photography sessions available at our lavender and flower fields.
              </p>
              <p>
                Sessions are available by appointment only.
              </p>
              <p>
                Lavender typically blooms from very late May to July, with June being the peak. Other varieties bloom from May through late Summer – and sometimes into fall. However, many factors, including weather, rain, heat, drought, etc, can affect the length and quality of blooms. We will be glad to book photography sessions for you during typical peak bloom times, but we cannot guarantee any day to be in a certain state of bloom. We are still growing and planting more lavender each year. Currently we have about 300 lavender plants and up to 2 acres of other flower fields. Our fields and property provide a beautiful location for photo sessions, but to fully appreciate the layout you should come see it. Feel free to view some photos at the bottom of this page, and also check our instagram feed for more photos.
              </p>
              <p>
                You are allowed to take photos anywhere on our property including the lavender and flower fields, outbuildings, shop building, trees, etc. We ask that you respect the property – this is also our home -, keep children supervised at all times.
              </p>
              <p>
                We accept all major credit/debit cards, CashApp, and Venmo.
              </p>
            </div>

            <div className="mt-16">
              <h3 className="font-default text-2xl text-foreground mb-6 text-center md:text-left">
                Contact us to Book Your Session
              </h3>
              <FormProvider>
                <form className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <input type="text" placeholder="Name" className="bg-muted/30 border border-transparent focus:border-primary focus:ring-1 focus:ring-primary rounded-md p-3 w-full outline-none transition-colors text-foreground placeholder:text-muted-foreground" />
                    <input type="email" placeholder="Email Address" className="bg-muted/30 border border-transparent focus:border-primary focus:ring-1 focus:ring-primary rounded-md p-3 w-full outline-none transition-colors text-foreground placeholder:text-muted-foreground" />
                  </div>
                  <textarea placeholder="Message" rows={5} className="bg-muted/30 border border-transparent focus:border-primary focus:ring-1 focus:ring-primary rounded-md p-3 w-full outline-none transition-colors text-foreground placeholder:text-muted-foreground resize-y"></textarea>
                  <div className="flex flex-col sm:flex-row justify-end items-center gap-4 pt-2">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <span>9 + 1 =</span>
                      <input type="text" className="w-12 p-2 bg-muted/30 border border-transparent focus:border-primary rounded-md text-center outline-none text-foreground" />
                    </div>
                    <Button variant="outline" className="w-full sm:w-auto border-foreground text-foreground hover:bg-foreground hover:text-background rounded-md px-8">
                      Submit
                    </Button>
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>

          {}
          <div className="flex flex-col">
            <div className="grid grid-cols-2 gap-4 mb-16">
              {galleryImages.map((img, i) => <div key={i} data-index={i} className="overflow-hidden rounded-md shadow-sm bg-muted/20">
                  <AspectRatio ratio={4 / 3}>
                    <img src={img.src} data-wvc-srcset={img.srcset} data-wvc-sizes={img.sizes} alt={img.alt} className="object-cover w-full h-full hover:scale-105 transition-transform duration-500 ease-in-out" loading="lazy" />
                  </AspectRatio>
                </div>)}
            </div>

            <div className="text-center md:text-left">
              <h3 className="font-default text-3xl text-foreground mb-4">
                Pricing and Booking Info
              </h3>
              <Separator className="w-16 h-1 bg-foreground mx-auto md:mx-0 mb-8" />
              
              <div className="space-y-8 text-left">
                <div>
                  <h4 className="font-default text-xl font-semibold text-foreground mb-2">
                    Peak Season Sessions
                  </h4>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong className="text-foreground font-medium">Private Sessions</strong> – <em className="italic">Sunrise (6am – 8am) or Sunset (6pm-8pm)</em><br />
                    $100 per hour (minimum 1 hour)
                  </p>
                </div>
                
                <div>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong className="text-foreground font-medium">Semi-Private Sessions</strong> – <em className="italic">There could be other photographers/clients on the property at the same time.</em><br />
                    $50 per hour (minimum 1 hour)
                  </p>
                </div>
              </div>

              <div className="mt-12 flex flex-col items-center">
                <h4 className="font-default text-2xl text-foreground mb-6 text-center">
                  Book Now with our Online Calendar!
                </h4>
                <Link to="#booking">
                  <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8 py-6 rounded-md uppercase tracking-wider font-semibold shadow-md hover:shadow-lg transition-all">
                    Book Online Here
                  </Button>
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}